
$(document).ready(function() {
   var ordernumber = $("#ordernumber").val();
   var shopifyOrderId = $("#shopifyOrderId").val();
   var awbnumber = $(".awbnumber").val();
   var awbUrl = $(".awbUrl").val();
  

if(awbnumber != "")
{
 var sentsms = $("#sentsms").val();
  if(sentsms == 0)
  {
    // $.ajax({
    //     url: "https://crossword.binaryic.in/index.php/api/sendOrderShipSMS",
    //     type: 'POST',
    //     dataType: 'json',
    //     async:false,
    //     data: {
    //         'shopifyorderID': shopifyOrderId,
    //         'trackingCode': awbnumber,
    //         'trackingUrl': awbUrl,
    //     },
    //     beforeSend: function() {
    //         // $("#report_generate").html('');
    //     },
    //     success: function(result) 
    //     {
    //      if(result.success == true)
    //       {
    //         $("#sentsms").val('1');
    //       } 
    //     }
    //  });
  }
  
}
 
  
  
   $('.order-return-qtn').css("display","none");

   var OrderCreatedDate = $("#OrderCreatedDate").val();
    //alert(OrderCreatedDate);  
   //var ordertimestamp = parseInt(OrderCreatedDate) + 1800000;

  var ordertimestamp = parseInt(OrderCreatedDate) + 300000;
   
   var d = new Date();
   var currenttimestamp = d.getTime();
   //alert(currenttimestamp);

  if(parseInt(currenttimestamp) > parseInt(ordertimestamp))
  {
    //alert("inner");
    //$('#cancelaction').css("display","block");
  }

  
 
if(ordernumber != "")
{
 $.ajax({
        url: "https://170c7c0b60a31d14551a0732c62f29b9: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@crosswordonline.myshopify.com/admin/api/2022-04/orders/"+shopifyOrderId+"/refunds.json",
        type: 'GET',
        dataType: 'json',
        async:false,
        beforeSend: function() {
            // $("#report_generate").html('');
        },
        success: function(result) 
        {
          console.log(result);
          var RefundAmount = 0;
          $.each(result.refunds, function(k, v) {
               $.each(v.refund_line_items, function(k, v) {
                 RefundAmount = RefundAmount + v.subtotal;
                 console.log(v.subtotal);
                 var skurqty = 0;
                    $.each(v.line_item, function(key, value) {

                      //var totalskuqty =   v.line_item.quantity;
                      //skurqty = parseInt(skurqty) + parseInt(v.quantity)
                      
                    if(key === "sku")
                    {
                      var skuCheck = value;
                      $('#uq-'+skuCheck).html(v.line_item.fulfillable_quantity);

                      $('#remainingqty-'+skuCheck).val(v.line_item.fulfillable_quantity);

                      var oiqty = parseInt(v.line_item.quantity) - parseInt(v.quantity);
                      var cqty = v.quantity;
                      //var cstr = cqty+" Quantity is cancelled and amount is refunded in to your account";
                      var cstr = cqty+" Quantity is cancelled and amount is refunded in to your account";
                      
                      if(v.line_item.fulfillable_quantity == 0)
                      {
                         var ostr = "Order Status for <span style='color: black; font-weight: 600;'>"+oiqty+" Quantity</span>";
                         $('#cancel-'+skuCheck).css("display","none");
                         $('#cancel-span-'+skuCheck).css("display","none");
                        // $('#cancel-msg-'+skuCheck).css("display","block");
                         $('#cancel-cmsg-'+skuCheck).css("display","block");
                         $('#cancel-cmsg-'+skuCheck).html(cstr);
                        $('#ostatus-'+skuCheck).html(ostr);
                      }
                      else
                      {
                        //var pqty = parseInt(v.line_item.quantity) - parseInt(v.line_item.fulfillable_quantity);
                         var pqty = parseInt(v.line_item.fulfillable_quantity);
                        if(pqty != 0)
                        {
                          
                            var sqty = "Select Quantity: <select  name='qty' id='qty' style='padding: 5px;border-radius: 5px;margin-right: 2px;'>";
                            for (var i = 1; i <= pqty; i++) {
                               sqty +="<option value="+i+">"+i+"</option>";
                              }
                              sqty +="</select>"; 
                           $('#cancel-span-'+skuCheck).html(sqty);
                           $('#cancel-span-'+skuCheck).css("display","none");
                          // $('#cancel-pmsg-'+skuCheck).css("display","block");
                           //$('#cancel-cmsg-'+skuCheck).css("display","block");
                          // $('#cancel-cmsg-'+skuCheck).html(cstr);

                          var ostr = "Order Status for <span style='color: black; font-weight: 600;'>"+oiqty+" Quantity</span>";
                          $('#ostatus-'+skuCheck).html(ostr);
                          
                        }
                      }
                      //console.log(">>>>>>>>",result);
                    }
                  });

                        
              });
           
         });
          if(result.refunds.length > 0)
          {
            //$('#refundamount').css("display","block");
             console.log(RefundAmount);
            // $("#refundamount").html("Total Refunded Amount: ₹"+RefundAmount);
          }
         
        }
    });

  
  // ON Load AJAX for get invoice pdf link from unicommerce 
    $.ajax({
        url: "https://crossword.binaryic.in/index.php/api/get-invoice-pfd",
        type: 'POST',
        dataType: 'json',
        async:false,
        data: {
            'ordernumber': ordernumber,
        },
        beforeSend: function() {
            // $("#report_generate").html('');
        },
        success: function(result) 
        {
          console.log(result);
          if(result.success == true)
          {
            console.log("Success True!");
          }
          else if(result.status == 'error')
          {
            console.log("Error On!");
            console.log(result);
          }
        }
    });
// END 
  

  
  // ON Load AJAX for sales order data get from unicommerce 
  
  //var ordernumber = '#1024';
  
    $.ajax({
        url: "https://crossword.binaryic.in/index.php/api/check-shipping-status",
        type: 'POST',
        dataType: 'json',
        async:false,
        data: {
            'ordernumber': ordernumber,
        },
        beforeSend: function() {
            // $("#report_generate").html('');
        },
        success: function(result) 
        {
          console.log(result);
          
          $('#saleOrderCode').val(result.salesOrderCode);
          
          if(result.success == true)
          {
             var returncode = "";
             var skuarray = [];
             var TotalQty = 0;
             $.each(result.salesOrderItems, function(k, v) {

                $('#orderFacility').val(v.facilityCode);
                console.log(result.skuitemcode);
                  console.log(result.skuitemcode[v.itemSku]);
               console.log(result.skuitemcode[v.itemSku].length);

                   var oiqty = parseInt(result.skuallitemcode[v.itemSku].length) - parseInt(result.skuallcancleitemcode[v.itemSku].length);
                   var canqty = parseInt(result.skuallcancleitemcode[v.itemSku].length);
                    if(result.skuallcancleitemcode[v.itemSku].length > 0)
                    {
                         var cstr = canqty+" Quantity is cancelled and amount is refunded in to your account";
                         $('#cancel-cmsg-'+v.itemSku).css("display","block");
                         $('#cancel-cmsg-'+v.itemSku).html(cstr);
                    }
                    
                          var ostr = "Order Status for <span style='color: black; font-weight: 600;'>"+oiqty+" Quantity</span>";
                          $('#ostatus-'+v.itemSku).html(ostr);

                          var awb = $('#awb-'+v.itemSku).val();

                    
                           if((parseInt(currenttimestamp) > parseInt(ordertimestamp)))
                              {
                                  //$('#cancelaction-'+v.itemSku).css("display","block");/* hide cancel btn  23_05_2023*/
                                 $('#cancelaction-'+v.itemSku).css("display","none");
                              }
                          
                           //$('#cancelaction-'+v.itemSku).css("display","block");
               if(oiqty > 0)
               {
                 
                  var sqty = "Select Quantity: <select  name='qty' id='qty' style='padding: 5px;border-radius: 5px;margin-right: 2px;'>";
                            for (var i = 1; i <= oiqty; i++) {
                               sqty +="<option value="+i+">"+i+"</option>";
                              }
                              sqty +="</select>"; 
                           $('#cancel-span-'+v.itemSku).html(sqty);
                           $('#cancel-span-'+v.itemSku).css("display","block");
               }
                         
                       

                      

                     /*if($.inArray(v.itemSku, skuarray) == -1)
                     {
                       TotalQty = TotalQty + 1;
                       skuarray.push(v.itemSku);
                     }*/
                    if($.inArray(v.code, result.returncodes) != -1)
                      {
                       result.skuitemcode[v.itemSku].splice($.inArray(v.code, result.skuitemcode[v.itemSku]), 1);
                        
                         //console.log(itemcodesku,'===',v.code);
                          //itemcodesku = itemcodesku.replace(v.code,'');
                        //console.log("replace: "+itemcodesku);
                        
                           /*if(returncode == "")
                           {
                                 returncode = v.code;
                           }
                          else
                           {
                                returncode = returncode+','+v.code;
                           }*/
                      }

                //var itemcodesku = result.skuitemcode[v.itemSku].toString();
               var itemcodesku = result.skuremreturnitemcode[v.itemSku].toString();

               $('#returncode-'+ v.itemSku).val(itemcodesku);

               if(result.returncodes.length > 0)
               {
               //if(result.skuitemcode[v.itemSku].length == 0)
               //{
                 //if(parseInt(result.skuallitemcode[v.itemSku].length) !=  parseInt(result.skuitemcode[v.itemSku].length))
                if(parseInt(result.skuallreturnitemcode[v.itemSku].length) > 0)
                 {
                   //var rrqty = parseInt(result.skuallitemcode[v.itemSku].length) -  parseInt(result.skuitemcode[v.itemSku].length);
                   var rrqty = parseInt(result.skuallreturnitemcode[v.itemSku].length);
                  var rstr = rrqty+" Quantity is return and your refund will be processed within 7 business days after it has been verified.";
                  $('#return-rmsg-'+v.itemSku).css("display","block");
                         $('#return-rmsg-'+v.itemSku).html(rstr);
                 }
                 
                 
               //}
               }

              
               /*if(result.returncodes.length > 0)
               {
                 
                 var rstr = result.returncodes.length+" Quantity is return and your refund will be processed within 7 business days after it has been verified.";
                  $('#return-rmsg-'+v.itemSku).css("display","block");
                         $('#return-rmsg-'+v.itemSku).html(rstr);
                 
               }*/

                if(v.reversePickable == true)
                {
                var ostr = "Order Status for <span style='color: black; font-weight: 600;'>"+result.skuitemcode[v.itemSku].length+" Quantity</span>";
                $('#ostatus-'+v.itemSku).html(ostr);
                }
            if(v.cancellable == false)
                {
               
                  //$('#cancel-msg-'+v.itemSku).css("display","block");
                  //$('#cancel-span-'+v.itemSku).css("display","none");
                  //$('#cancel-'+v.itemSku).css("display","none");
               
                  $('.buy').css("display","block");
                  
                }
               
                if(v.reversePickable == false)
                {
                   //$('#return-'+v.itemSku).css("display","none");
                }

                $('#saleItemCode-'+ v.itemSku).val(v.channelSaleOrderItemCode);

               if(v.shippingPackageStatus == "READY_TO_SHIP" || v.shippingPackageStatus == "MANIFESTED" || v.shippingPackageStatus == "DISPATCHED" || v.shippingPackageStatus == "PACKED")
               {
                  $('#cancelaction-'+v.itemSku).css("display","none");
               }

               if(v.statusCode == "CREATED" || v.statusCode == "FULFILLABLE" || v.statusCode == "UNFULFILLABLE")
              {
                 //$('#cancelaction-'+v.itemSku).css("display","block");
                 var status = '<ul><li class="active">Order Received</li><li>Ready for Shipping</li><li>In-Transit</li><li>Out for delivery</li><li>Delivered</li></ul>';
              }

              if(v.statusCode == "READY_TO_DISPATCH")
              {
                 $('#cancelaction-'+v.itemSku).css("display","none");
                 var status = '<ul><li class="active">Order Received</li><li class="active">Ready for Shipping</li><li>In-Transit</li><li>Out for delivery</li><li>Delivered</li></ul>';
              }

              if(v.statusCode == "DISPATCHED")
              {
                  var ostr = "Order Status for <span style='color: black; font-weight: 600;'>"+result.skuallitemcode[v.itemSku].length+" Quantity</span>";
                  $('#ostatus-'+v.itemSku).html(ostr);
                 var status = '<ul><li class="active">Order Received</li><li class="active">Ready for Shipping</li><li class="active">In-Transit</li><li>Out for delivery</li><li>Delivered</li></ul>';
              }
              
              if(v.statusCode == "DELIVERED")
              {
                 var ostr = "Order Status for <span style='color: black; font-weight: 600;'>"+result.skuallitemcode[v.itemSku].length+" Quantity</span>";
                  $('#ostatus-'+v.itemSku).html(ostr);
                 //var status = '<ul><li class="active">Order Received</li><li class="active">Ready for Shipping</li><li class="active">In-Transit</li><li class="active">Out for delivery</li><li class="active">Delivered</li></ul>';
                 var status = '<ul><li class="active">Delivered</li></ul>';
              
              }

              if((v.statusCode == "CANCELLED") && (v.reversePickable == true))
              {
                 var status = '<ul><li class="active">Order Received</li><li class="active">Refunded</li></ul>';
              }

               if((v.statusCode == "CANCELLED") && (v.reversePickable == false))
              {
                var ostr = "Order Status for <span style='color: black; font-weight: 600;'>"+result.skuallcancleitemcode[v.itemSku].length+" Quantity</span>";
                $('#ostatus-'+v.itemSku).html(ostr);
                 var status = '<ul><li class="active">Order Received</li><li class="active">Cancelled</li><li class="active">Refunded</li></ul>';
              }

               if((v.statusCode == "CANCELLED") && (v.reversePickable == false) && (v.reversePickupCode != null))
              {
                 var ostr = "Order Status for <span style='color: black; font-weight: 600;'>"+result.skuallreturnitemcode[v.itemSku].length+" Quantity</span>";
                       $('#ostatus-'+v.itemSku).html(ostr);
                 var status = '<ul><li class="active">Order Received</li><li class="active">Delivered</li><li class="active">Return initiated</li><li class="active">Return Pickedup</li><li class="active">Refunded</li></ul>';
                 $('#status-'+ v.itemSku).html(status);
              }

                if((parseInt(result.skuallcancleitemcode[v.itemSku].length) == parseInt(result.skuallitemcode[v.itemSku].length)) )
                 {
                    $('#cancelaction-'+v.itemSku).css("display","none");
                 }

              $('#status-'+ v.itemSku).html(status);
           
            //if(v.shippingPackageStatus == "DELIVERED")
             if(v.statusCode == "DELIVERED")
            {
              var lnupdt = new Date(v.updated + 259200000);//last updated line item + 3 days miliseconds
               var currentdate = new Date();
               if(lnupdt.getTime() != currentdate.getTime())
               {
                 if(v.reversePickable == false)
                  {
                     $('.order-return-qtn').css("display","none");
                   $('#return-'+v.itemSku).css("display","none");
                     $('#returnaction-'+ v.itemSku).css("display","none");
                  }
                 else
                 {
                   $('#returnaction-'+ v.itemSku).css("display","block");
                   $('.order-return-qtn').css("display","block");
                    $('#return-'+ v.itemSku).css("display","block");
                 }

                  $('#return-'+ v.itemSku).attr("data-salesOrderCode-"+v.itemSku,result.salesOrderCode); 
                  $('#return-'+ v.itemSku).attr("data-code-"+v.itemSku,v.code); 


                 if(result.skuallitemcode[v.itemSku].length > 0)
                 {
                   //var rrq = parseInt(result.skuallitemcode[v.itemSku].length) - parseInt(result.skuallreturnitemcode[v.itemSku].length);
                   var rrq = parseInt(result.skuremreturnitemcode[v.itemSku].length);
                   var sqty = "Select Quantity: <select  name='rqty' id='rqty' style='padding: 5px;border-radius: 5px;margin-right: 2px;'>";
                            for (var i = 1; i <= rrq; i++) {
                               sqty +="<option value="+i+">"+i+"</option>";
                              }
                              sqty +="</select>"; 
                           $('#return-span-'+v.itemSku).html(sqty);
                 }


                 if(parseInt(result.skuitemcode[v.itemSku].length) != 0 && v.statusCode == "DELIVERED")
                 {
                   if(parseInt(result.skuallreturnitemcode[v.itemSku].length) > 0)
                   {
                       var ostr = "Order Status for <span style='color: black; font-weight: 600;'>"+result.skuallreturnitemcode[v.itemSku].length+" Quantity</span>";
                       $('#ostatus-'+v.itemSku).html(ostr);
                       var status = '<ul><li class="active">Order Received</li><li class="active">Delivered</li><li class="active">Return initiated</li><li>Return Pickedup</li><li>Refunded</li></ul>';
                       $('#status-'+ v.itemSku).html(status);
                   }
                   else
                   {
                       var ostr = "Order Status for <span style='color: black; font-weight: 600;'>"+result.skuitemcode[v.itemSku].length+" Quantity</span>";
                       $('#ostatus-'+v.itemSku).html(ostr);
                       var status = '<ul><li class="active">Order Received</li><li class="active">Delivered</li></ul>';
                       $('#status-'+ v.itemSku).html(status);
                   }
                   
                 }

                 if(parseInt(result.skuitemcode[v.itemSku].length) == 0 && v.statusCode == "DELIVERED")
                 {
                    var ostr = "Order Status for <span style='color: black; font-weight: 600;'>"+result.skuallreturnitemcode[v.itemSku].length+" Quantity</span>";
                    $('#ostatus-'+v.itemSku).html(ostr);
                    var status = '<ul><li class="active">Order Received</li><li class="active">Delivered</li><li class="active">Return initiated</li><li>Return Pickedup</li><li>Refunded</li></ul>';
                    $('#status-'+ v.itemSku).html(status);
                 }

                 if(parseInt(result.skuitemcode[v.itemSku].length) == 0 && v.statusCode == "RETURNED")
                 {
                    var ostr = "Order Status for <span style='color: black; font-weight: 600;'>"+result.skuallreturnitemcode[v.itemSku].length+" Quantity</span>";
                    $('#ostatus-'+v.itemSku).html(ostr);
                    var status = '<ul><li class="active">Order Received</li><li class="active">Delivered</li><li class="active">Return initiated</li><li class="active">Return Pickedup</li><li class="active">Refunded</li></ul>';
                    $('#status-'+ v.itemSku).html(status);
                 }
               }
              
            }
                $('#uq-'+v.itemSku).html(result.skuallitemcode[v.itemSku].length);

               $('#cancelaction-'+v.itemSku).css("display","none");
           });
             
           
          }
          else if(result.status == 'error')
          {
            console.log("Error On!");
            console.log(result);
          }
        }
    });


  //check invoice pdf
  
    $.ajax({
        url: "https://crossword.binaryic.in/index.php/api/checkOrderPdfFile",
        type: 'POST',
        dataType: 'json',
        async:false,
        data: {
            'ordernumber': ordernumber,
        },
        beforeSend: function() {
            // $("#report_generate").html('');
        },
        success: function(result) 
        {
          console.log(result);
          
          ordernumber = ordernumber.replace("#", "");
          if(result.success == true)
          {
             $('#invoice').css("display","block");
              $("#invoice").html('<a href="https://crossword.binaryic.in/public/order_invoice_pdf/'+ordernumber+'.pdf" target="_blank" style="color: white;">Invoice</a>');
           
          }
          else if(result.success == false)
          {  
            $('#invoice').css("display","none");
            $("#invoice").html('');
          }
        }
    });
}


  // Cancel Order Button Click on MY Order page to cancel order
  $('.cancelOrder').on('click', function(e){
    //console.log($(this).parent().parent().parent().children('#lineItemID').val());
    //return false;

  
      var ordernumber = $("#ordernumber").val();
      var shopifyorderID = $("#shopifyorderID").val();
      var skuid = $(this).parent().parent().parent().children('#skuid').val();
      var lineItemID = $(this).parent().parent().parent().children('#lineItemID').val();
      var qty = ($(this).parent().parent().children().children().children('#qty').val()) ? $(this).parent().parent().children().children().children('#qty').val() : "1";
   
      var originalqty = $(this).parent().parent().parent().children('#lineitemqty').val();  
   
      var RemainingQty = parseInt(originalqty) - parseInt(qty);
    
  $.ajax({
        url: "https://crossword.binaryic.in/index.php/api/check-shipping-status",
        type: 'POST',
        dataType: 'json',
        async:false,
        data: {
            'ordernumber': ordernumber,
        },
        beforeSend: function() {
            // $("#report_generate").html('');
        },
        success: function(result) 
        {
          console.log(result);
          
          $('#saleOrderCode').val(result.salesOrderCode);
          
          if(result.success == true)
          {
            var flag = false;
             $.each(result.salesOrderItems, function(k, v) {
                if(v.shippingPackageStatus == "READY_TO_SHIP")
               {
                    //$('#cancel-awbmsg-'+v.itemSku).css("display","block");
                 $('#ctnrqedmsg-'+v.itemSku).css("display","block");
                     $('#ctnrqedmsg-'+v.itemSku).html("You can't cancel Order Item because order shipping process start.");
                   //alert("You can't cancel Order Item because order shipping process start.");
                 setTimeout(function () {   
                        window.location.reload();      
                 }, 1000);
                 
               }
               else
                {
          
                   flag = true;
                  
                }
          });

            if(flag == true)
            {

               console.log(ordernumber,shopifyorderID,skuid,lineItemID);
                   $.ajax({
                             url: "https://crossword.binaryic.in/index.php/api/cancel-order",
                             type: 'POST',
                             dataType: 'json',
                             data: {
                                'ordernumber': ordernumber,
                                'shopifyorderID': shopifyorderID,
                                'skuid' : skuid,
                                'lineItemID': lineItemID,
                                'qty': qty
                              },
                             beforeSend: function() {
                                  // $("#report_generate").html('');
                               },
                             success: function(result) {
                                    $('#remainingqty-'+skuid).val(RemainingQty);
                                   if(RemainingQty == 0)
                                      {
                                         $('#uq-'+skuid).html(RemainingQty);
                                         $('#cancel-span-'+skuid).css("display","none");
                                         $('#cancel-'+skuid).css("display","none");
                                        //$('#cancel-msg-'+skuid).css("display","block");
                                      }
                                     else
                                      {  
                                          $('#cancel-span-'+skuid).css("display","block");
                                           //$('#cancel-pmsg-'+skuid).css("display","block");
                                      }
                                         console.log(result);
                                          setTimeout(function () {
                                             $('#ctnrqedmsg-'+skuid).css("display","block");
                                                $('#ctnrqedmsg-'+skuid).html("Order Item Successfully cancelled.");
                                            
                                                window.location.reload();      
                                          }, 1000);
                
                                        //return 
                                    }
                            });
              
            }



            
          }
        }
     });
    
      
        
  });
  
  // return Order Button Click on MY Order page to cancel order

    $('.return').on('click', function(e){

      var originalqty = $(this).parent().parent().children('#lineitemqty').val(); 
     var sku = $(this).data("id");
     var saleOrderCode =  $("#saleOrderCode").val();
      var orderFacility =  $("#orderFacility").val();
      var shopifyOrderName = $("#shopifyOrderName").val();
     var lineItemID = $(this).parent().parent().children('#lineItemID').val();
     var qty = $('#remainingqty-'+sku).val();
     var returnremainingqty = $('#returnremainingqty-'+sku).val();

      var returncodestr = $('#returncode-'+sku).val();
      var rqty = ($(this).parent().children().children().children('#rqty').val());
      if(rqty == undefined)
      {
        rqty = 1;
      }
      var RemainingQty = parseInt(returnremainingqty) - parseInt(rqty);
      
      console.log(sku,saleOrderCode,lineItemID,qty);
      
       $.ajax({
            url: "https://crossword.binaryic.in/index.php/api/createReversePickup",
            type: 'POST',
            dataType: 'json',
            data: {
                 'shopifyOrderName': shopifyOrderName,
                'saleOrderCode': saleOrderCode,
                'saleOrderItemCode': lineItemID,
                'qty': qty,
                'rqty': rqty,
                'orderFacility': orderFacility,
                'returnremainingqty': returnremainingqty,
                'returncodestr': returncodestr
            },
            beforeSend: function() {
                // $("#report_generate").html('');
            },
            success: function(result) {
               console.log(result);
               if(result.success == true)
              {
                $('#returnremainingqty-'+sku).val(RemainingQty);
                 $('#return-'+sku).css("display","none");
                 setTimeout(function () {
                    $('#ctnrqedmsg-'+sku).css("display","block");
                     $('#ctnrqedmsg-'+sku).html(result.message);
                     window.location.reload();    
                 }, 1000);
                
                 //return 
              }
            }
        });
  });



  
 /* $('.Return1').on('click', function(e){
    
      var sku = $(this).data("id");
    
	  var itemsku = $(this).data("id").toLowerCase();
	  var salesOrderCode = $(this).data('salesordercode-'+itemsku);
	  var code = $(this).data('code-'+itemsku);
	  var returnReason = "return reason";
    
      console.log(salesOrderCode,code,returnReason);
       $.ajax({
            url: "https://crossword.binaryic.in/index.php/api/return-order",
            type: 'POST',
            dataType: 'json',
            data: {
                'salesOrderCode': salesOrderCode,
                'code': code,
                'returnReason' : returnReason
            },
            beforeSend: function() {
                // $("#report_generate").html('');
            },
            success: function(result) {
               console.log(result);
               if(result.success == true)
              {
                 $('#return-'+sku).css("display","none");
                 setTimeout(function () {
                     $('#ctnrqedmsg-'+sku).html(result.message);
                     window.location.reload();    
                 }, 1000);
                
                 //return 
              }
            }
        });
  });*/



 
});

